export default __webpack_public_path__ + "static/media/sideImage5.aef2cafb.png";